<h2 mat-dialog-title>Standard: {{ reportStandardName }}</h2>
<form #form="ngForm" [formGroup]="reportStandardForm" (ngSubmit)="save(true)" novalidate  class="flex-col gap-1em" autocomplete="off">
  <mat-dialog-content>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Uppfylld</mat-label>
        <mat-select formControlName="fulfilled">
          <mat-option>Välj...</mat-option>
          <mat-option [value]="-1">Ej tillämplig</mat-option>
          <mat-option [value]="0">Ej uppfylld</mat-option>
          <mat-option [value]="1">Uppfylld</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Tidigare uppfylld</mat-label>
        <mat-select formControlName="previousFulfilled">
          <mat-option></mat-option>
          <mat-option [value]="-1">Ej tillämplig</mat-option>
          <mat-option [value]="0">Ej uppfylld</mat-option>
          <mat-option [value]="1">Uppfylld</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Beskrivning</mat-label>
        <textarea matInput rows="8" formControlName="description"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Förslag</mat-label>
        <textarea matInput rows="8" formControlName="suggestions"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Antal förslag</mat-label>
        <input matInput formControlName="noOfSuggestions" maxlength="2" min="0" max="99" type="number" />
        @if (getFormControl('noOfSuggestions').hasError('min')) {
          <mat-error>Antal förslag måste vara minst 0</mat-error>
        }
        @if (getFormControl('noOfSuggestions').hasError('max')) {
          <mat-error>Antal förslag måste vara mindre än 100</mat-error>
        }
      </mat-form-field>
    </div>
    @if (getFormControl('previousSuggestions').value != '') {
      <div class="flex-row flex-col-ltmd gap-col-1em">
        <mat-form-field class="flex-1">
          <mat-label>Tidigare förslag</mat-label>
          <textarea matInput rows="8" formControlName="previousSuggestions"></textarea>
        </mat-form-field>
      </div>
    }
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Frågor/noteringar</mat-label>
        <textarea matInput rows="8" formControlName="internalNotes"></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (hasPermissionToChange$ | async) {
      <button mat-raised-button type="submit" color="primary" title="{{'commands.SaveAndClose' | translate }}">{{ 'commands.SaveAndClose' | translate }}</button>
    }
    @if (hasPermissionToChange$ | async) {
      <button mat-raised-button type="button" (click)="save(false)" color="accent" title="{{'commands.Save' | translate }}">{{ 'commands.Save' | translate }}</button>
    }
    <button mat-raised-button type="button" (click)="cancel()">{{ 'commands.Close' | translate }}</button>
  </mat-dialog-actions>
</form>
